module.exports = __webpack_public_path__ + "img/noche-pangue.32082317.jpg";